<template>
  <ul v-if="errors.length">
    <li v-for="(error, index) in errors" :key="index" class="error_li">{{ error }}</li>
  </ul>
</template>
<script setup>
import ErrorHandler from '../js/error-handler.js'
import { computed, defineProps } from 'vue';
const props = defineProps({
  errorsHash: {
    type : Object,
    required : true
  }
})

const errors = computed(() => ErrorHandler.errorsToArray(props.errorsHash))

</script>
<style>
.error_li {
  color: #ff0000
}
</style>
